import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  const guideLinks = [
    { label: t("guides.review.title"), to: "/guide/usfans-review" },
    { label: t("guides.shipping.title"), to: "/guide/shipping-cost" },
    { label: t("guides.warehouse.title"), to: "/guide/warehouse" },
    { label: t("guides.coupon.title"), to: "/guide/coupon" },
  ];

  const resourceLinks = [
    { label: t("nav.spreadsheet"), to: "/#what-is" },
    { label: t("nav.categories"), to: "/#categories" },
    { label: t("nav.safety"), to: "/#safety" },
    { label: t("faq.title"), to: "/#faq" },
  ];

  return (
    <footer className="bg-background-100 text-foreground-800">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                USFans{" "}
                <span className="font-medium text-foreground-600">
                  Spreadsheet
                </span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              {t("footer.about")}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              {t("footer.guides")}
            </h4>
            <ul className="mt-4 space-y-2.5">
              {guideLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              {t("footer.resources")}
            </h4>
            <ul className="mt-4 space-y-2.5">
              {resourceLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              {t("footer.company")}
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("cta.visitStore")}
                </a>
              </li>
              <li>
                <Link
                  to="/#what-is"
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("whatIs.title")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">
            {t("footer.disclaimer")}
          </p>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-foreground-500">
              © {new Date().getFullYear()} USFans Spreadsheet.{" "}
              {t("footer.rights")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}